import { render, staticRenderFns } from "./IrrigationControl.vue?vue&type=template&id=70b6448b&scoped=true&"
import script from "./IrrigationControl.vue?vue&type=script&lang=js&"
export * from "./IrrigationControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b6448b",
  null
  
)

export default component.exports